import {MouseEvent} from "@agm/core";
import {Component, Input, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import {Service} from "../../../../../models/service";
import {ServiceLocation} from "../../../../../models/service-location";
import {ServiceLocationControllerService} from "../../../../../services/location-controller/service-location-controller.service";
import {RegistrationControllerService} from "../../../../../services/registration-controller/registration-controller.service";
import {ServiceControllerService} from "../../../../../services/service-controller/service-controller.service";
import {BaseError} from "../../../base-error";

@Component({
  selector: "registration-region",
  templateUrl: "./region-registration.component.html",
  styles: [`
    agm-map {
      height: 80vh;
    }`,
  ],
  providers: [RegistrationControllerService, ServiceLocationControllerService, ToastrService],
})
export class RegistrationRegionComponent extends BaseError implements OnInit {

  @Input() public serviceId: string;
  public showMarkerModal = false;
  public showAddWarningModal = false;
  public addEvent;
  public modalIndex: number;
  public lat = 13.70134227785247;
  public lng = -89.22443389892578;
  public zoom = 10;
  public service: Service;
  public serviceLocations: ServiceLocation[];

  constructor(private serviceControllerService: ServiceControllerService,
              private registrationController: RegistrationControllerService,
              private serviceLocationController: ServiceLocationControllerService,
              public toastr: ToastrService,
              public pos: ToastrService,
              private router: Router) {
    super(toastr);
  }

  public ngOnInit(): void {
    this.serviceLocationController.getServiceLocations(this.serviceId)
      .subscribe((response) => this.serviceLocations = response,
        (err) => this.showErrorMessage(err));

    this.serviceControllerService.getService(this.serviceId).subscribe(
      (data: Service) => this.service = data,
      (err) => this.showErrorMessage(err),
    );
  }

  public mapClicked(event: MouseEvent) {
    this.showAddWarningModal = true;
    this.addEvent = event;
  }

  public submitAddEvent() {
    this.showAddWarningModal = false;
    if (!this.serviceLocations) {
      this.serviceLocations = [];
    }
    const serviceLocation = new ServiceLocation();
    serviceLocation.lat = this.addEvent.coords.lat;
    serviceLocation.lng = this.addEvent.coords.lng;
    serviceLocation.name = this.service.name;
    this.doInsert(serviceLocation);
  }

  public dragEnd(event: MouseEvent, index: number) {
    const serviceLocation = this.serviceLocations[index];
    serviceLocation.lat = event.coords.lat;
    serviceLocation.lng = event.coords.lng;
    this.doSave(serviceLocation);
  }

  public clickedMarker(label: string, index: number) {
    this.showMarkerModal = true;
    this.modalIndex = index;
  }

  public doAction(event: any) {
    if (event === "save") {
      this.doSave(this.serviceLocations[this.modalIndex]);
    } else if (event === "delete") {
      this.doDelete();
    } else {
      this.doCancel();
    }
  }

  private doInsert(registratioLocation: ServiceLocation) {
    this.serviceLocationController.createServiceLocation(this.serviceId, registratioLocation).subscribe(
      (data) => {
        this.serviceLocations.push(data);
        this.showMarkerModal = true;
        this.modalIndex = this.serviceLocations.indexOf(data);
      },
      (error) => this.showErrorMessage(error),
    );
  }

  private doSave(registratioLocation: ServiceLocation) {
    if (registratioLocation && registratioLocation.id) {
      this.serviceLocationController.saveServiceLocation(this.serviceId, registratioLocation).subscribe(
        (data) => {
          this.showMarkerModal = false;
        },
        (error) => this.showErrorMessage(error),
      );
    } else {
      this.showErrorMessage("System error! Registration location does not have ID!");
    }
  }

  private doDelete() {
    const serviceLocation = this.serviceLocations[this.modalIndex];
    if (serviceLocation.id) {
      this.serviceLocationController.deleteServiceLocation(serviceLocation.id).subscribe(
        (data) => {
          this.serviceLocations.splice(this.modalIndex, 1);
          this.showMarkerModal = false;
        },
        (error) => this.showErrorMessage(error),
      );
    } else {
      this.serviceLocations.splice(this.modalIndex, 1);
      this.showMarkerModal = false;
    }
  }

  private doCancel() {
    this.ngOnInit();
    this.showMarkerModal = false;
  }

}
